import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const noItemsStyles = {
  wrapper: (): SystemStyleObject<Theme> => ({
    textAlign: "center",
    margin: "40px auto 0",
    width: "100%",
  }),
  centerText: (): SystemStyleObject<Theme> => ({
    textAlign: "center",
  }),
};

export default noItemsStyles;
